import * as React from 'react';

const facebookIconWhite = (<svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M28.7298 14.4228C28.7298 6.45712 22.3121 0 14.3966 0C6.47752 0.00179165 0.0598145 6.45712 0.0598145 14.4246C0.0598145 21.6217 5.30219 27.5879 12.1535 28.67V18.592H8.51642V14.4246H12.1571V11.2444C12.1571 7.63065 14.2981 5.63475 17.5714 5.63475C19.1409 5.63475 20.7803 5.91604 20.7803 5.91604V9.46351H18.9725C17.1934 9.46351 16.638 10.5761 16.638 11.7174V14.4228H20.6119L19.9776 18.5902H16.6362V28.6682C23.4875 27.5861 28.7298 21.6199 28.7298 14.4228Z" fill="#B1BCCF"/>
</svg>);

export default facebookIconWhite; 
